import DataService from './DataService';
import ApiConstant from './ApiContstant';
class LoginService {

    async login(email: any, password: any) {
        return DataService.postData(localStorage.getItem('tenantUrl') + ApiConstant.LoginAuth, {
            "EmailId": email,
            "Password": password,
            "CaptchaInputText": ""
        });
    }

    async validateSSO(ssoUrl: any) {
        return (DataService.getData(ssoUrl));
    }

    async logout() {
        return (DataService.getData(localStorage.getItem('tenantUrl') + ApiConstant.LogOut));
    }
}

export default new LoginService;
